"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Header = exports.InstancesContainer = void 0;
/**
 * Package import
 */
const styled_1 = __importDefault(require("@emotion/styled"));
/**
 * Style
 */
exports.InstancesContainer = styled_1.default.div({
    width: '100%',
});
exports.Header = styled_1.default.div({
    borderBottom: '1px solid #CFD8E3',
    padding: '2rem',
    height: '7rem',
    width: '100%',
    h2: {
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '150%',
        fontSize: '2rem',
        letterSpacing: '-0.69px',
        userSelect: 'none',
    }
});
exports.Content = styled_1.default.div({
    padding: '0 2rem',
    overflow: 'auto',
    maxWidth: '100%',
    width: '100%',
    height: 'calc(100% - 7rem)',
});
